import { Injectable } from '@angular/core';
import { Registration } from '../../domain/ot-event';
import { L10nService } from './l10n.service';
import { TrustPayService } from './trust-pay.service';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BasicDialogComponent } from '../dialog/basic-dialog/basic-dialog.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { plainToClass } from 'class-transformer';

export class PaymentCodeResponse {
  paymentCode: string;
  qrCodeImage: string;
}

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  private static registrationPath = '/registration';
  private registrationUrl: string;

  constructor(
      private l10nService: L10nService,
      private trustPayService: TrustPayService,
      private router: Router,
      private modalService: NgbModal,
      private httpClient: HttpClient) {
    this.registrationUrl = environment.publicApiUrl + RegistrationService.registrationPath;
  }

  public calculatePrices(registration): Promise<any> {
    const url = this.registrationUrl + '/calculatePrices';
    return this.httpClient.post<any>(url, registration).toPromise().then(plainObject => plainToClass(Registration, plainObject));
  }

  public create(registration: Registration, recaptchaValue: string): Promise<Registration> {
    const url = this.registrationUrl + (recaptchaValue ? '?recaptcha=' + encodeURIComponent(recaptchaValue) : '');
    return this.httpClient.post(url, registration).toPromise().then(plainObject => plainToClass(Registration, plainObject));
  }

  public afterRegistrationCreated(createdRegistration, cityId: number): void {
    if (createdRegistration.paymentTypeConfig && createdRegistration.paymentTypeConfig.paymentTypeCode === 'trustPay') {
      this.trustPayService.paymentUrl(createdRegistration.id, createdRegistration.secureHash).then(trustPayUrl => {
        const redirectToTrustPay = function() {
          window.location.href = trustPayUrl;
        };
        // Redirect user to TrustPay if he doesn't
        const trustPayTimeoutToken = window.setTimeout(redirectToTrustPay, 10000);

        const modalRef: NgbModalRef = this.modalService.open(BasicDialogComponent, { size: 'sm' });
        (<BasicDialogComponent> modalRef.componentInstance).title = this.l10nService.get('personalData_paymentRedirect_title');
        (<BasicDialogComponent> modalRef.componentInstance).body = this.l10nService.get(
            'personalData_paymentRedirect_info',
            [this.l10nService.get('paymentGateway_trustPay')]);

        modalRef.result.then(() => {
          redirectToTrustPay();
          window.clearTimeout(trustPayTimeoutToken);
        });
      });
    } else {
      this.router.navigateByUrl('/city/' + cityId
          + '/ot/event/' + createdRegistration.otEvent.id
          + '/registration/' + createdRegistration.id
          + '/' + createdRegistration.secureHash + '/success');
    }
  }

  public getByIdAndHash(registrationId: number, secureHash: string): Promise<Registration> {
    const url = this.registrationUrl + '/getByIdAndHash?id=' + registrationId + '&secureHash=' + encodeURIComponent(secureHash);
    return this.httpClient.get(url).toPromise().then(plainObject => plainToClass(Registration, plainObject));
  }

  public getPaymentCode(registrationId: number, secureHash: string): Promise<PaymentCodeResponse> {
    const url = this.registrationUrl + '/' + registrationId + '/' + encodeURIComponent(secureHash) + '/paymentCode';
    return this.httpClient.get<PaymentCodeResponse>(url).toPromise();
  }
}
